import { config } from '../../../config';
import { fetchWithAuth } from '../fetchWithAuth';

const base = () => `${config().catalogueServiceBaseUrl}/back-office/avatar-items`;

async function request(path, options = {}) {
    const res = await fetchWithAuth(`${base()}${path}`, options);
    if (!res.ok) {
        const body = await res.json().catch(() => ({}));
        throw new Error(body.error || res.statusText);
    }
    return res.json();
}

const json = (method, body) => ({
    method,
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(body),
});

export const avatarItemsApi = {
    list: () => request('/'),
    create: (input) => request('/', json('POST', input)),
    update: (id, input) => request(`/${id}`, json('PUT', input)),
    remove: (id) => request(`/${id}`, { method: 'DELETE' }),
};
